import { nanoid } from 'nanoid/async'
import { App } from '../../App.js'
import CONST_SOCKET from '../../const/socket'
import { quickReplyModal } from './quickReplyModal'
import { 
  createNewPostbackNode,
  updateNodeConnections,
  removeConnectionsHavingUnmatch, 
} from '../../utils/functions'

// eslint-disable-next-line
export default async (node, editor) => {
  const oldData = node.data
  const { value: quickReplyData } = await quickReplyModal(oldData, node)

  if (quickReplyData && Object.values(quickReplyData).length > 0) {

    // Create text unique ID if there is not any
    if (! ('uniqueId' in node.data)) {
      node.data.uniqueId = await nanoid(15)
    }

    Object.assign(node.data, quickReplyData)

    if ('newPostback' === quickReplyData.replyType) {
      if (node.outputs instanceof Map) {
        const mapToArray = Array.from(node.outputs)
        
        if (mapToArray[0][1]) {
          const nodeObject = mapToArray[0][1]

          // If Button node has no connection then
          if (0 === nodeObject.connections.length) {
            attachNewPostbackToQuickReplyNode(node)    
          }
        }
      }
    }

    node.update()
    updateNodeConnections(node)

    const match = ['newPostback']
    removeConnectionsHavingUnmatch(node, match, CONST_SOCKET.QUICK_REPLY_OUTPUT)   
  }

  return false
}

const attachNewPostbackToQuickReplyNode = async (node) => {
  const newPostbackNode = await createNewPostbackNode()
  newPostbackNode.position = [node.position[0] + 250, node.position[1]]

  App.editor.addNode(newPostbackNode)

  App.editor.connect(
    node.outputs.get(CONST_SOCKET.QUICK_REPLY_OUTPUT),
    newPostbackNode.inputs.get(CONST_SOCKET.NEW_POSTBACK_INPUT)
  )
}